import * as React from "react";
const SvgFiRrDiamondTurnRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-diamond-turn-right_svg__a)">
      <path
        fill="#062147"
        d="M22.543 8.481 15.52 1.457a4.984 4.984 0 0 0-7.037 0L1.457 8.481a4.984 4.984 0 0 0 0 7.037l7.024 7.024a4.96 4.96 0 0 0 3.52 1.454 4.96 4.96 0 0 0 3.518-1.454l7.024-7.024a4.984 4.984 0 0 0 0-7.037m-1.414 5.623-7.024 7.024a2.984 2.984 0 0 1-4.209 0l-7.025-7.024a2.98 2.98 0 0 1 0-4.209l7.025-7.024a2.98 2.98 0 0 1 4.21 0l7.023 7.024a2.98 2.98 0 0 1 0 4.21m-4-5.226a3 3 0 0 1 0 4.242l-2.422 2.421a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L15.421 12h-4.42a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0v-3c0-1.654 1.345-3 3-3h4.42l-2.128-2.128a.999.999 0 1 1 1.414-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-diamond-turn-right_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiamondTurnRight;
